import { createNullableProvideInject } from '@collector/shared-ui'

import { HistoryFiltersConfig } from '../configuration'

export const [provideHistoryFiltersConfig, injectHistoryFiltersConfig] =
  createNullableProvideInject<HistoryFiltersConfig>('historyFiltersConfig')
